module.exports = __webpack_public_path__ + "img/tab2_likes@3x.aec55230.png";